var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{attrs:{"text-center":"","w-100":"","pb-5":"","fx":"","fxcenter":""}},[_c('div',{staticClass:"inner-wrapper"},[_c('div',{attrs:{"bold":""}},[_vm._v("MyJFrog allows you to manage your company's JFrog cloud subscriptions.")]),_c('div',{attrs:{"pt-2":""}},[_vm._v("Log in to get going!")])])])
}]

export { render, staticRenderFns }